var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "btn-group", attrs: { role: "group" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary btn-icon btn-rounded",
            staticStyle: {
              margin: "1rem 0rem",
              position: "absolute",
              top: "5px",
              left: "10px",
              "z-index": "1"
            },
            attrs: { type: "button" },
            on: { click: _vm.resetLocation }
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("gps_fixed")]),
            _vm._v("\n            Reset")
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "gmap-map",
        {
          staticStyle: { width: "100%", height: "400px" },
          attrs: {
            center: _vm.center,
            zoom: _vm.currentZoom || _vm.marker.zoom,
            options: _vm.mapOptions
          },
          on: { zoom_changed: _vm.onZoomChanged }
        },
        [
          _c("gmap-marker", {
            attrs: {
              position: _vm.marker.position,
              clickable: true,
              draggable: !_vm.readonly
            },
            on: {
              dragend: _vm.onDragEnd,
              click: function($event) {
                _vm.center = _vm.marker.position
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b824002", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b824002","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/MapMarkerComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1b824002","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/form-elements/MapMarkerComponent.vue
// module chunks = 0